import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=07bdbb60&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=07bdbb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bdbb60",
  null
  
)

export default component.exports